import { render, staticRenderFns } from "./companyIntroduce.vue?vue&type=template&id=7cbb7d0b&scoped=true&"
import script from "./companyIntroduce.vue?vue&type=script&lang=js&"
export * from "./companyIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./companyIntroduce.vue?vue&type=style&index=0&id=7cbb7d0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbb7d0b",
  null
  
)

export default component.exports